import TextEditor, { initialValue, serialize } from './TextEditor';
export default TextEditor;
export { initialValue, serialize };
